interface EmailParams {
  name: string;
  email: string;
  phone?: string;
  message: string;
  interests?: string[];
}

export const sendEmail = async (params: EmailParams) => {
  try {
    // Validate required fields
    if (!params.name || !params.email) {
      throw new Error('Name and email are required');
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(params.email)) {
      throw new Error('Invalid email format');
    }

    const response = await fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form-name': 'contact',
        ...params,
        interests: params.interests?.join(', ') || ''
      }).toString()
    });

    if (!response.ok) {
      throw new Error('Failed to submit form');
    }

    return response;
  } catch (error) {
    console.error('Form submission error:', error);
    throw error;
  }
};